<div class="w-screen h-screen bg-white fixed">
  <div class="" *ngIf="showTab">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      <a
        mat-tab-link
        class="min-w-5 p-0 capitalize m-auto"
        *ngFor="let link of ['collect', 'send', 'withdraw']"
        [active]="tab == link"
        (click)="tab = link; handleTabTransition()">
        {{ link }}
      </a>
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  </div>

  <div class="flex flex-col min-h-full max-w-md m-auto">
    <ew-general-financial-tool
      [tab]="tab"
      [showTitle]="false"
      *ngIf="!isTabTransitioning"></ew-general-financial-tool>
  </div>
</div>
